import * as React from 'react';
import { Translatable } from 'common/i18n';
import { useTranslation } from 'common/i18n/hooks';
import { react2panel } from 'common/util/react2panel';
import { WarningHeroReact } from './index';
import { NoDataReason, WarningHeroReportName, WarningHeroTheme } from './constants';
export type NoDataHeroProps = {
  bodyText?: Translatable;
  reportName: WarningHeroReportName;
  reason?: NoDataReason;
};
export type NoDataHeroJsxProps = {
  props: NoDataHeroProps;
};
export function NoDataHeroReact(props: NoDataHeroProps) {
  const {
    t
  } = useTranslation();
  let headerText: string = t("insights.no-data.default");
  if (props.reason === NoDataReason.EmptyProject) {
    headerText = t("insights.no-data.empty-project");
  } else if (props.reason === NoDataReason.Timeout) {
    headerText = t("insights.no-data.timeout");
  }
  return <WarningHeroReact theme={WarningHeroTheme.NoData} headerText={headerText} report={props.reportName} bodyText={props.bodyText || ""} data-sentry-element="WarningHeroReact" data-sentry-component="NoDataHeroReact" data-sentry-source-file="no-data-hero.tsx" />;
}
export const NoDataHeroPanel = react2panel("mp-no-data-hero", NoDataHeroReact);